// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SEARCH_FILTER_VALUE: "SEARCH_FILTER_VALUE",
  SEARCH_GET_POSTMORTEMS_REQUEST: "SEARCH_GET_POSTMORTEMS_REQUEST",
  SEARCH_GET_POSTMORTEMS_SUCCESS: "SEARCH_GET_POSTMORTEMS_SUCCESS",
  SEARCH_GET_POSTMORTEMS_FAILURE: "SEARCH_GET_POSTMORTEMS_FAILURE",
}
